module.exports = __webpack_public_path__ + "img/logo_sider.47ea48a6.png";